import { IconButton, Layout, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo } from "react"

import { SLIDE_OUT_IDS } from "../../layouts"
import { modelIconMapping } from "../../mappings/icons"

type LeftSlideOutButtonProps = Omit<ComponentPropsWithRef<typeof IconButton>, "children">

export const LeftSlideOutButton = memo<LeftSlideOutButtonProps>((props) => {
	return (
		<Layout.SlideOutTrigger slideOutId={SLIDE_OUT_IDS.LEFT}>
			<IconButton {...props}>
				<LuIcon icon={modelIconMapping.leftPanel} />
			</IconButton>
		</Layout.SlideOutTrigger>
	)
})
LeftSlideOutButton.displayName = "LeftSlideOutButton"
